import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { Link, useNavigate } from "react-router";

// store
import { fetchUnreadCount } from "../../../../reducer/slices/notifications/unread-count";
import { useDispatch } from "react-redux";

// api
import axios from "axios";
import { ENDPOINTS } from "../../../../js/api/_config";
import { convertTimeToLocation,formatDateStatus } from "../../constant/constant";

const NotificationsPanelContent = ({
  activeTab,
  setActiveTab,
  notifications,
  loadingNotifications,
  fetchMore,
  hasMore,
  toggleDropdown,
  listRef
}) => {
  const colors = ["bg-[#EBDDEC] text-[#AC7EBC]", "bg-[#DFDEEE] text-[#6764AB]"];
  const navigate = useNavigate();
  
  const dispatch = useDispatch();

  const markAsRead = async (notificationId) => {
    try {
      await axios.put(
        `${ENDPOINTS.NOTIFICATION.MARK_AS_READ}=${notificationId}`,
        null
      );
      dispatch(fetchUnreadCount());
    } catch (error) {
      console.error("Error marking as read:", error);
    }
  };

  const handleScroll = () => {
    const el = listRef.current;
    if (!el) return;

    const bottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 10;

    if (bottom && hasMore && !loadingNotifications) {
      fetchMore();
    }
  };

  useEffect(() => {
    const el = listRef.current;
    if (!el) return;

    el.addEventListener("scroll", handleScroll);
    return () => el.removeEventListener("scroll", handleScroll);
  }, [hasMore, loadingNotifications]);

  return (
    <div className="w-[461px] bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden notifications-panel-popup">
      <div className="p-4 border-b border-gray-100">
        <h2 className="text-lg font-semibold text-gray-800">Notifications</h2>
      </div>

      <div className="flex items-center gap-3 px-4 py-2 border-b border-gray-100">
        {["All", "Unread"].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-4 py-1 rounded-full text-sm font-medium transition ${
              activeTab === tab
                ? "bg-[#245cea29] text-[#245CEA]"
                : "text-[#87909E] bg-[#F0F1F3]"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      <div
        ref={listRef}
        className="min-h-[420px] max-h-[420px] overflow-y-auto p-3 pl-0 pb-0 thin-scroll"
      >
        {notifications &&
          notifications.length > 0 &&
          notifications.map((n, index) => (
            <Link
              key={n.id}
              className="flex items-start gap-3 p-3 pt-0 mb-2.5 rounded-lg bg-white cursor-pointer"
              onClick={() => {
                if (!n.isRead) {
                  markAsRead(n.notificationID).then(() => {
                    toggleDropdown();
                    navigate(
                      `/conversation-list/${n.patientTrialJuncID}?conversation_type=all`
                    );
                  });
                }
              }}
              to={`/conversation-list/${n.patientTrialJuncID}?conversation_type=all`}
            >
              <div className="flex mt-auto mb-auto">
                {!n.isRead ? (
                  <div className="w-2 h-2 rounded-full bg-[#278EFF] mr-2 mt-auto mb-auto" />
                ) : (
                  <div className="w-2 h-2 rounded-full mr-2" />
                )}

                <div className="flex items-center">
                  <div
                    className={`w-10 h-10 rounded-full text-[14px] flex items-center justify-center font-semibold ${
                      colors[index % 2]
                    }`}
                  >
                    {`${n.firstName[0]}${n.lastName[0]}`}
                  </div>
                </div>
              </div>

              <div className="flex-1">
                <div
                  className="text-[16px] text-[#060427]"
                  dangerouslySetInnerHTML={{ __html: n.primaryMsg }}
                />
                <p className="text-xs text-[#373737] mt-1 line-clamp-2">
                  {n.secondaryMsg}
                </p>
              </div>

              <div className="text-xs text-[#667783] whitespace-nowrap">
                {formatDateStatus(convertTimeToLocation(n.createdAt))}
              </div>
            </Link>
          ))}

        {loadingNotifications && (
          <div className="text-center py-2 text-gray-400 flex justify-center">
            <div className="mini-spinner mt-3"></div>
          </div>
        )}

        {!loadingNotifications && notifications.length == 0 && (
          <p className="text-center py-2 text-gray-400">
            No more notifications
          </p>
        )}
      </div>
    </div>
  );
};

export default function NotificationsPanel(props) {
  return createPortal(
    <div className="absolute top-16 right-[100px] z-[20]">
      <NotificationsPanelContent {...props} />
    </div>,
    document.body
  );
}
